import React, { useMemo, useState } from "react";
import "./AgentQueueList.css";

const TABS = [
  { key: "all", label: "All" },
  { key: "unassigned", label: "Unassigned" },
  { key: "mine", label: "Mine" },
];

/**
 * AgentQueueList
 * Left-hand queue of incoming conversations waiting for an agent.
 *
 * Props:
 *  - conversations: [{
 *      id, visitorName, lastMessage, waitMinutes, priority,
 *      status: "unassigned" | "assigned", assignedToMe
 *    }]
 *  - selectedId
 *  - onSelect(id)
 */
export default function AgentQueueList({
  conversations = [],
  selectedId = null,
  onSelect = () => {},
}) {
  const [tab, setTab] = useState("all");

  const filtered = useMemo(() => {
    if (tab === "unassigned") {
      return conversations.filter((c) => c.status === "unassigned");
    }
    if (tab === "mine") {
      return conversations.filter((c) => c.assignedToMe);
    }
    return conversations;
  }, [conversations, tab]);

  return (
    <div className="cb-panel cb-queue-panel">
      <div className="cb-queue-header">
        <h3>Conversation Queue</h3>
        <span className="cb-queue-count">{filtered.length}</span>
      </div>

      <div className="cb-queue-tabs">
        {TABS.map((t) => (
          <button
            key={t.key}
            className={`cb-queue-tab ${tab === t.key ? "active" : ""}`}
            onClick={() => setTab(t.key)}
          >
            {t.label}
          </button>
        ))}
      </div>

      <div className="cb-queue-list">
        {filtered.length === 0 && (
          <div className="cb-queue-empty">No conversations in this view.</div>
        )}

        {filtered.map((c) => (
          <div
            key={c.id}
            className={`cb-queue-item ${selectedId === c.id ? "selected" : ""}`}
            onClick={() => onSelect(c.id)}
          >
            <div className="cb-queue-item-top">
              <span className="cb-visitor-name">{c.visitorName}</span>
              <span className={`cb-priority-badge cb-priority-${c.priority}`}>
                {c.priority}
              </span>
            </div>
            <div className="cb-queue-item-msg">{c.lastMessage}</div>
            <div className="cb-queue-item-bottom">
              <span className="cb-wait-time">Waiting {c.waitMinutes}m</span>
              <span className="cb-wait-time">
                {c.status === "unassigned" ? "Unassigned" : "Assigned"}
              </span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
